module.exports = __webpack_public_path__ + "img/price-details.8ef9101b.jpg";